import api from './api';
import { Tag, TagUsage } from '../types';

export interface CreateTagRequest {
  name: string;
  color?: string;
  description?: string;
}

export interface UpdateTagRequest {
  name?: string;
  color?: string;
  description?: string;
}

interface TagListResponse {
  data: Tag[];
  total: number;
}

export const tagService = {
  list: async (): Promise<Tag[]> => {
    const response = await api.get<TagListResponse>('/tags');
    return response.data.data;
  },

  get: async (id: string): Promise<Tag> => {
    const response = await api.get<Tag>(`/tags/${id}`);
    return response.data;
  },

  create: async (data: CreateTagRequest): Promise<Tag> => {
    const response = await api.post<Tag>('/tags', data);
    return response.data;
  },

  update: async (id: string, data: UpdateTagRequest): Promise<Tag> => {
    const response = await api.put<Tag>(`/tags/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/tags/${id}`);
  },

  usage: async (id: string): Promise<TagUsage[]> => {
    const response = await api.get<TagUsage[]>(`/tags/${id}/usage`);
    return response.data;
  },
};
